import React from 'react';
import { Link } from 'react-router-dom';
import TableLoader from './TableLoader';

const UsuariosTable = ({ 
  usuarios, 
  loading
}) => {
  if (loading) {
    return <TableLoader />;
  }

  return (
    <div className="table-responsive">
      <table className="table align-items-center mb-0">
        <thead>
          <tr>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nome</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Perfil</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ativo</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ações</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map((usuario) => (
            <tr key={usuario.id}>
              <td className="text-xs mb-0">{usuario.name}</td>
              <td className="text-xs mb-0">{usuario.username}</td>
              <td className="text-xs mb-0">{usuario.userRole.name}</td>
              <td className="text-xs mb-0">
                <span className={`badge ${usuario.enabled ? 'bg-success' : 'bg-danger'}`}>
                  {usuario.enabled ? 'Ativo' : 'Inativo'}
                </span>
              </td>
              <td className="text-xs font-weight-bold mb-0">
                <Link to={`/Usuarios/AlterarSenha/${usuario.id}`} title="Alterar Senha" className="me-3">
                  <i className="bi bi-key text-info"></i>
                </Link>
                <Link to={`/Usuarios/Editar/${usuario.id}`} title="Editar" className="me-3">
                  <i className="bi bi-pencil-square text-primary"></i>
                </Link>
                <Link to={`/Usuarios/Excluir/${usuario.id}`} title="Excluir">
                  <i className="bi bi-trash text-danger"></i>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UsuariosTable; 